export const APP_VERSION = 'app_version';
